import { render, staticRenderFns } from "./profile_notifications.page.vue?vue&type=template&id=4a95e008&"
import script from "./profile_notifications.page.vue?vue&type=script&lang=js&"
export * from "./profile_notifications.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports